import React from "react";

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const StyledButton: React.FC<Props> = ({
  className = "",
  children,
  ...otherProps
}) => {
  return (
    <button {...otherProps} className={className + " styled-button"}>
      {children}
    </button>
  );
};

export default StyledButton;
